export default __webpack_public_path__ + "static/media/zoomInDot.a66354e8.svg";